import { useEffect, useState } from 'react';
import {
  marketplaceCartService,
  CART_EVENT_NAME,
} from '../services/marketplaceCartService';

export const useMarketplaceCartCount = (): number => {
  const [count, setCount] = useState(() =>
    marketplaceCartService.getItemCount(),
  );

  useEffect(() => {
    const updateCount = () => {
      setCount(marketplaceCartService.getItemCount());
    };

    const handleCustomEvent = (event: Event) => {
      const customEvent = event as CustomEvent<number>;
      if (typeof customEvent.detail === 'number') {
        setCount(customEvent.detail);
        return;
      }
      updateCount();
    };

    window.addEventListener(CART_EVENT_NAME, handleCustomEvent);
    window.addEventListener('storage', updateCount);

    return () => {
      window.removeEventListener(CART_EVENT_NAME, handleCustomEvent);
      window.removeEventListener('storage', updateCount);
    };
  }, []);

  return count;
};
